"use strict";
/* eslint-disable import/no-cycle */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrendingArticles = void 0;
var Collection_1 = require("./Collection");
var TrendingArticles = /** @class */ (function (_super) {
    __extends(TrendingArticles, _super);
    function TrendingArticles() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrendingArticles.prototype.getArticleById = function (id) {
        return this.items
            .map(function (trendingArticle) { return trendingArticle.getArticles().getById(id); })
            .find(function (article) { return article !== undefined; });
    };
    return TrendingArticles;
}(Collection_1.Collection));
exports.TrendingArticles = TrendingArticles;
